import { render, staticRenderFns } from "./DeletedMiddlemansTable.vue?vue&type=template&id=f261dae4&"
import script from "./DeletedMiddlemansTable.vue?vue&type=script&lang=ts&"
export * from "./DeletedMiddlemansTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports